<template>
  <div class="vip-container">
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getKey, judgeClientSystem } from '../../assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
export default {
  name: 'lVip',
  methods: {
    ...mapActions('vip', [
      'memberInfo'
    ])
  },
  data () {
    return {
    }
  },
  async mounted () {
    if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS' && window.history.length > 1 && this.$route.query.noExit !== 'Y') {
      jsBridge('exit')
    }

    const vips = {
      'ENJOY': '/vip/svip',
      'LIGHT_ENJOY': '/vip/lvip',
      'OLD': '/vip/ovip',
      'SVIP': '/vip/preindex',
      'XMVIP_API': '/vip/xmvip' // 小美会员
    }
    const vipDetailPath = {
      BC_HY: '/vip/ovip', // 会员半年卡
      BC_M: '/vip/ovip', // 会员月卡
      BC_Y: '/vip/ovip', // 会员年卡
      EC_HY: '/vip/svip', // 尊享版半年卡
      EC_M: '/vip/svip', // 尊享版月卡
      EC_Y: '/vip/svip', // 尊享版年卡
      LC_HY: '/vip/lvip', // 轻享版半年卡
      LC_M: '/vip/lvip', // 轻享版月卡
      LC_Y: '/vip/lvip', // 轻享版年卡
      SC_HY: '/vip/preindex', // 小美SVIP半年卡
      SC1_HY: '/vip/preindex', // 小美SVIP半年
      FAC_M: '/privilege/credit/speed', // 授信提速卡·月卡
      GC_M: '/vip/bvip', // 小美大权益·月卡
      GPC_Q: '/vip/bvip', // 小美大权益pro·
      XAC_M: '/vip/xmvip', // 小美会员
      RAC_M: '/privilege/credit/retrial', // 授信重审卡
      RWC_M: '/privilege/withdraw/retrial', // 提现重审卡
      SKC_M: '/vip/skc', // 至尊王卡
      UPC_M: '/vip/up' // up
    }

    const origin = process.env.VUE_APP_PAYURL
    let { target, couponRecordId, purchaseSVIP, type, couponType, svipSource, status, loanApplyNo, findTarget, more } = this.$route.query || {}
    let gid = localStorage.getItem('gid')
    let token = getKey('userInfo', 'token') || ''
    const channel = getKey('channel') || ''
    let data = `gid=${gid}&token=${token}&channel=${channel}&refurl=${window.location.origin}`
    couponRecordId && (data += `&couponRecordId=${couponRecordId}&couponType=${couponType}`)
    purchaseSVIP && (data += `&purchaseSVIP=${purchaseSVIP}`)
    svipSource && (data += `&svipSource=${svipSource}`)
    type && (data += `&type=${type}`)
    status && (data += `&status=${status}`)
    loanApplyNo && (data += `&loanApplyNo=${loanApplyNo}`)
    if (findTarget) {
      // 如果是小美VIP 跳前置页面
      if (more === 'Y' && ['BC_HY', 'BC_M', 'BC_Y', 'EC_HY', 'EC_M', 'EC_Y', 'LC_HY', 'LC_M', 'LC_Y'].includes(findTarget)) {
        return window.location.replace(`${origin}/vip/preIndex?${data}`)
      }
      return window.location.replace(`${origin}${vipDetailPath[findTarget]}?${data}`)
    }
    const res = await this.memberInfo()
    let { memberGoodsGroupCd, meetSVIP, memberStatus, showPrivilege } = res.data || {} 
    if (res.success) {
      // 只有要特权卡信息，则直接跳转权益中心页面
      if (showPrivilege) {
        return window.location.replace(`${origin}/vip/ssvip/pre?${data}`)
      } else if (target === 'svip') { // 判断是否需要过ssvip
        if (memberGoodsGroupCd === 'SVIP') { // 判断是否买过ssvip
          if (['NORMAL', 'FROZEN'].includes(memberStatus)) {
            return window.location.replace(`${origin}/vip/ssvip?${data}`)
          } else if (meetSVIP) { // 来源于我的界面 并有ssvip资格
            if (['withDraw', 'withSvip', 'result', 'middle'].includes(purchaseSVIP)) {
              return window.location.replace(`${origin}/vip/ssvip?${data}`)
            } else {
              return window.location.replace(`${origin}/vip/ssvip/pre?${data}`)
            }
          } else { // 来源于我的界面 并有vip资格
            return window.location.replace(`${origin}/vip/preindex?${data}`)
            // return this.$router.replace({ path: '/vip/preindex', query: { type } })
          }
        } else if (meetSVIP) { // 判断ssvip是否有资格
          if (['withDraw', 'withSvip', 'result', 'middle', 'home'].includes(purchaseSVIP)) {
            return window.location.replace(`${origin}/vip/ssvip?${data}`)
          } else {
            return window.location.replace(`${origin}/vip/ssvip/pre?${data}`)
          }  
        } 
      }
      if (!memberGoodsGroupCd) {
        return window.location.replace(`${origin}/vip/preindex?${data}`)
        // return this.$router.replace({ path: '/vip/preindex', query: { type } })
      } else {
        if (memberGoodsGroupCd === 'SVIP' && ['NORMAL', 'FROZEN'].includes(memberStatus)) {
          window.location.replace(`${origin}/vip/ssvip?${data}`)
        } else {
          window.location.replace(`${origin}${vips[memberGoodsGroupCd]}?${data}`)
          // this.$router.replace(vips[memberGoodsGroupCd])
        }
      }
    }
  }
}
</script>
